import { PriceFormat } from '../utils/formatPrice';
export function buildInitialState() {
    return {
        selectedSelections: {},
        priceFormat: PriceFormat.fraction,
        loading: false,
        open: false,
        searched: false,
        value: '',
        popularQueries: [],
        previousQueries: [],
        entries: [],
        entriesTimestamp: 0,
        categories: {},
        sports: [],
        selectedSport: null,
        queryIDs: {},
    };
}
//# sourceMappingURL=state.js.map